import React from 'react';
import Card from 'components/common/Card';
import Theme from 'Theme';

import { SuccessContain, SuccessText, PaddingBottom, MarginBottom } from './Styled';

export const RegisterSuccess = () => {
  return (
    <SuccessContain>
      <Card.Title color={Theme.brandColor}>Registration Success</Card.Title>
      <MarginBottom />
      <SuccessText>You have successfully registered for an account. Please check your email to activate your account</SuccessText>
      <PaddingBottom />
    </SuccessContain>
  );
};

export default RegisterSuccess;
